import { isLocalCoproducerId } from '@entities/partnership'

export const COPRODUCER_DRAFT_EMAIL_PATH = 'coproducers.draft.email'

export function coproducerEmailRequiredMessage() {
  return 'Informe o e-mail do coprodutor.'
}

export function coproducerEmailInvalidMessage() {
  return 'Informe um e-mail válido.'
}

export function isValidCoproducerEmail(value: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())
}

export function coproducerEmailFieldPath(coproducerId?: string) {
  return coproducerId ? `coproducers.${coproducerId}.email` : COPRODUCER_DRAFT_EMAIL_PATH
}

export function validateProductCoproduction(
  coproducers: readonly { id: string; email: string }[],
  options?: { requireEmail?: boolean },
): Partial<Record<string, string>> {
  const errors: Partial<Record<string, string>> = {}
  const requireEmail = options?.requireEmail === true

  if (coproducers.length === 0) {
    if (requireEmail) {
      errors[COPRODUCER_DRAFT_EMAIL_PATH] = coproducerEmailRequiredMessage()
    }
    return errors
  }

  for (const coproducer of coproducers) {
    const email = coproducer.email.trim()
    const path = coproducerEmailFieldPath(coproducer.id)
    const mustHaveEmail = requireEmail || isLocalCoproducerId(coproducer.id)

    if (!email) {
      if (mustHaveEmail) {
        errors[path] = coproducerEmailRequiredMessage()
      }
      continue
    }

    if (!isValidCoproducerEmail(email)) {
      errors[path] = coproducerEmailInvalidMessage()
    }
  }

  return errors
}
